import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { connectCareTermsAndConditionsSelector } from 'store/consumerPreferences/selectors';

export const consumerSelector = (state: RootState) => state.amwell.consumer.information;

export const consumerDataSelector = createSelector(consumerSelector, c => c.data);
export const consumerDataErrorSelector = createSelector(consumerSelector, c => c.errors.data);
export const consumerDataLoadingSelector = createSelector(consumerSelector, c => c.loading.data);

export const consumerTokenSelector = createSelector(consumerSelector, c => c.token);
export const consumerTokenErrorSelector = createSelector(consumerSelector, c => c.errors.token);
export const consumerTokenLoadingSelector = createSelector(consumerSelector, c => c.loading.token);

export const consumerActionErrorSelector = createSelector(consumerSelector, c => c.errors.action);
export const consumerActionLoadingSelector = createSelector(
  consumerSelector,
  c => c.loading.action
);

export const consumerLoadingSelector = createSelector(
  [consumerDataLoadingSelector, consumerTokenLoadingSelector, consumerActionLoadingSelector],
  (dataLoading, tokenLoading, actionLoading) => dataLoading || tokenLoading || actionLoading
);

export const consumerAuthenticatedSelector = createSelector(
  [consumerDataSelector, connectCareTermsAndConditionsSelector],
  (consumer, acceptedTermsAndConditions) => !!consumer && acceptedTermsAndConditions
);
